import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import calendar from '../../../assets/images/Dashboard/calendar-icon.svg'
import DatePicker from "react-datepicker";

const enablingOptions = [
    { value: "Enable", label: "Enable" },
    { value: "Disable", label: "Disable" }
]

const AddTaskMaster = (props) => {

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-leave-modal' centered >
                <Modal.Header closeButton>
                    <Modal.Title>Add Task Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Task Number <span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Task Name <span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Description<span className="required-asterisk">*</span></label>
                                        <Form.Control type="text" />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>Trans Start Date <span className="required-asterisk">*</span> </label>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd-MM-yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            placeholderText='DD/MM/YYYY'
                                            dropdownMode="select"
                                            maxDate={new Date()}
                                            required
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className='add-customer-calendar-container'>
                                        <label>Trans Finish Date<span className="required-asterisk">*</span> </label>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd-MM-yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            placeholderText='DD/MM/YYYY'
                                            dropdownMode="select"
                                            maxDate={new Date()}
                                            required
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={props.handleNextStep} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddTaskMaster;
